import { pipe } from 'fp-ts/function';
import { map } from 'fp-ts/lib/Either';

import { Decoding, ErrorAsync, Http } from '@catawiki/runtime-toolkit';

import { csrfRoute } from '../constants/apiRoutes';
import { Csrf } from '../models/csrf';
import { setServerHeader } from './request';

export async function fetchCsrf(): ErrorAsync.PromiseEither<string> {
  return pipe(Http.get(csrfRoute), setServerHeader(), Http.send<Csrf>())
    .then(Decoding.decodeWith(Csrf))
    .then(map(({ csrf }) => csrf))
    .catch(ErrorAsync.errorToLeft);
}
